import { pxToRem } from 'styles/functions'

const Theme = {
  body_background_color: '#e1610f',

  logo_image_url: 'incroyableshistoires.png',
  logo_height: 140,

  token_url: 'incroyableshistoires.png',
  token_width: 74,
  token_margin_left: 18,
  token_margin_top: 12,

  number_weight: 700,
  number_size: 32,
  number_font: `'Open Sans', sans-serif`,
  number_hidden_tokenIds: [0],

  button_color: '#e1610f',

  text_font: `'Questrial', sans-serif`,

  title_font: `'Open Sans', sans-serif`,
  title_margin: `0 0 0 ${pxToRem(5)}`,

  legend_color: '#4C4B4B',

  separator_height: 4,
  separator_color: '#e1610f',
}

export default Theme
